import { Language } from 'interfaces/Language'
import ApiService from './ApiService'
import { ReportType, UserReportRequest } from 'interfaces/UserReport'

const UserReportService = {
    getReasons(type: ReportType, interfaceLanguage: Language) {
        ApiService.interceptors.request.use((config) => {
            if (config.headers !== undefined) {
                config.headers['X-Interface-Language'] = interfaceLanguage
            }
            return config
        })
        return ApiService.get(`/reports/user-reasons?reportType=${type}`).then((response) => {
            return response.data.content
        })
    },

    create(userReport: UserReportRequest) {
        return ApiService.post(`/reports`, userReport).then((response) => {
            return response.data
        })
    },
}

export default UserReportService
